import {
  CheckoutBlockDto,
  CreateExperienceDto,
  ExperienceDevicePreviewDto,
  ExperienceDto,
  ExperienceFe,
  TabEnumFe,
} from "@intelligems/ig-types";

export const getExperienceDtoFromFe = (
  experience: ExperienceFe,
  checkoutBlocks: CheckoutBlockDto[]
): CreateExperienceDto | ExperienceDto => {
  return {
    id: experience.id,
    name: experience.name,
    isPreview: experience.isPreview,
    description: experience.description,
    devicePreview: experience.devicePreview,
    type: experience.type,
    category: experience.category,
    status: experience.status,
    testTypes: experience.testTypes,
    experienceAnalysis: {
      ...experience.experienceAnalysis,
      analyticsViewType:
        experience.testTypes.hasTestCheckoutBlocks &&
        !checkoutBlocks.some((block) => block.blockType === "upsell")
          ? "sitewide_orders"
          : experience.experienceAnalysis.analyticsViewType,
    },
    experienceIntegrations: experience.experienceIntegrations,
    isExternal: experience.isExternal,
    shippingTestMethodDefinitions: experience.shippingTestMethodDefinitions,
    currency: experience.currency,
    pausedAtTs: experience.pausedAtTs,
    startedAtTs: experience.startedAtTs,
    endedAtTs: experience.endedAtTs,
    requiresLink: experience.requiresLink,
    linkBaseUrl: experience.linkBaseUrl,
    productVariantCount: experience.productVariantCount,
    shippingCarrierProvider:
      experience.shippingCarrierProvider ?? "intelligems",
    experienceActions: experience.experienceActions,
  };
};

export const getExperienceFeFromDto = (
  experienceDto: ExperienceDto
): ExperienceFe => {
  return {
    ...experienceDto,
    shippingTestMethodDefinitions:
      experienceDto.shippingTestMethodDefinitions || [],
    shippingCarrierProvider:
      experienceDto.shippingCarrierProvider ?? "intelligems",
    devicePreview: getDevicePreviewFeFromDto(experienceDto.devicePreview),
    tab:
      experienceDto.category === "personalization"
        ? TabEnumFe.MODS
        : TabEnumFe.TEST_GROUPS,
    viewMode: experienceDto.archivedAtTs ? "view" : "edit",
    actionMode: "edit",
    experienceAnalysis: experienceDto.experienceAnalysis,
    experienceIntegrations: experienceDto.experienceIntegrations,
  };
};

const getDevicePreviewFeFromDto = (
  devicePreview: ExperienceDevicePreviewDto | null | undefined
): ExperienceDevicePreviewDto => {
  return devicePreview || { device: "desktop", path: "/" };
};
